import React from 'react'

export default function TopBanner() {
  return (
    <div className='my-top-banner' >
      <div>
      </div>
    </div>
  )
}
